<script>
  import Icon from '../Icon/Icon.svelte';

  export let type = 'text',
    id = null,
    name = '',
    placeholder = '',
    required = false,
    checked = false,
    pattern = null,
    title = null,
    value = null,
    hasError = false,
    readonly = false,
    minlength = null,
    maxlength = null,
    errorMessages = [],
    onKeyup = null,
    testid = null;

  let passwordToggle = true,
    hasErrors;

  const togglePasswordVisibility = type === 'password';

  const tooglePasswordVisibility = () => {
    passwordToggle = !passwordToggle;
    type = passwordToggle ? 'password' : 'text';
  };

  $: hasErrors = hasError || (errorMessages && errorMessages.length);
</script>

<style lang="scss">
  @import '../../styles/settings/core';
  @import '../../styles/settings/global';
  @import '../../styles/settings/colors';

  input[type='password'],
  input[type='text'].toggle-password {
    padding-inline-end: 3.5rem;

    :global([dir='rtl']) & {
      padding-inline: 3.5rem unset;
    }
  }

  .input {
    font-size: spacing(2);
    font-family: inherit;
    line-height: spacing(3);
    letter-spacing: -0.2px;
    height: 4.8rem;
    width: 100%;
    border-radius: 0.4rem;
    border: 1px solid $grey-20;
    background-color: $white;
    padding: #{spacing(1.5)} spacing(2);
    transition: border-color 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
    margin-block-end: spacing(1);
    background-clip: padding-box;
  }

  .input-container {
    position: relative;
    fill: $grey-40;
  }

  .error {
    background-color: $bright-red-10;
    border: 2px solid #f10202;
  }

  .error.togglePasswordVisibilityContainer {
    background-color: $bright-red-10;
    border: none;
  }

  .error-message {
    color: #f10202;
  }

  input[type='checkbox'] {
    z-index: 3000;
    height: 4rem;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    width: 4rem;

    :global([dir='rtl']) & {
      left: auto;
      right: 0;
    }
  }

  .checkbox-label {
    display: block;
    padding: 0 0 0 3.2rem;
    font-size: spacing(2);
    line-height: 24px;
    letter-spacing: -0.2px;
    text-transform: none;
    color: $black;
    font-weight: 400;
    margin: 0 !important;

    :global([dir='rtl']) & {
      padding: 0 3.2rem 0 0;
    }
  }

  .checkbox-label::before {
    content: '';
    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNiIgaGVpZ2h0PSIyNiIgdmlld0JveD0iMCAwIDI2IDI2Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZmlsbD0iI0ZGRiIgZmlsbC1vcGFjaXR5PSIwIiBkPSJNMSAxaDI0djI0SDF6Ii8+CiAgICAgICAgPHBhdGggZmlsbD0iI0NDQyIgZD0iTTIwLjA3MSA0SDUuOTNBMS45MyAxLjkzIDAgMCAwIDQgNS45MjlWMjAuMDdBMS45MyAxLjkzIDAgMCAwIDUuOTI5IDIySDIwLjA3QTEuOTMgMS45MyAwIDAgMCAyMiAyMC4wNzFWNS45M0ExLjkzIDEuOTMgMCAwIDAgMjAuMDcxIDR6bS0uMjQgMTYuMDcxSDYuMTdhLjI0Mi4yNDIgMCAwIDEtLjI0MS0uMjRWNi4xN2MwLS4xMzMuMTA4LS4yNDEuMjQtLjI0MUgxOS44M2MuMTMzIDAgLjI0MS4xMDguMjQxLjI0VjE5LjgzYS4yNDIuMjQyIDAgMCAxLS4yNC4yNDF6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=');
    background-repeat: no-repeat;
    height: 4rem;
    width: 4rem;
    left: 0;
    top: 0;
    position: absolute;
    background-position: left top;

    :global([dir='rtl']) & {
      left: auto;
      right: 0;
      background-position: right top;
    }
  }

  .checkbox-label::after {
    content: '';
    opacity: 0;
    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iYSIgZD0iTTE5LjA3MSAyMUg0LjkzQTEuOTI5IDEuOTI5IDAgMCAxIDMgMTkuMDcxVjQuOTNDMyAzLjg2MyAzLjg2MyAzIDQuOTI5IDNIMTkuMDdDMjAuMTM3IDMgMjEgMy44NjMgMjEgNC45MjlWMTkuMDdBMS45MjkgMS45MjkgMCAwIDEgMTkuMDcxIDIxem0tOC4yMjQtMy45NGw3LjM5My03LjM5M2EuNjQzLjY0MyAwIDAgMCAwLS45MDlsLS45MDktLjkwOWEuNjQzLjY0MyAwIDAgMC0uOTA5IDBsLTYuMDMgNi4wMy0yLjgxNC0yLjgxNmEuNjQzLjY0MyAwIDAgMC0uOTEgMGwtLjkwOC45MWEuNjQzLjY0MyAwIDAgMCAwIC45MDlsNC4xNzggNC4xNzhhLjY0My42NDMgMCAwIDAgLjkxIDB6Ii8+CiAgICA8L2RlZnM+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiPgogICAgICAgICAgICA8cGF0aCBmaWxsPSIjRkZGIiBmaWxsLW9wYWNpdHk9IjAiIGQ9Ik0wIDBoMjR2MjRIMHoiLz4KICAgICAgICAgICAgPHVzZSBmaWxsPSIjRkY1QzI4IiB4bGluazpocmVmPSIjYSIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==');
    background-repeat: no-repeat;
    height: 4rem;
    width: 4rem;
    position: absolute;
    left: 0;
    top: 0;
    background-position: left top;
    transition: all 300ms ease-in-out;

    :global([dir='rtl']) & {
      left: auto;
      right: 0;
      background-position: right top;
    }
  }

  input[type='checkbox']:checked + .checkbox-label::after {
    opacity: 1;
  }

  input[type='checkbox']:focus + .checkbox-label::before {
    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNiIgaGVpZ2h0PSIyNiIgdmlld0JveD0iMCAwIDI2IDI2Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZmlsbD0ibm9uZSIgZD0iTTEgMWgyNHYyNEgxeiIvPgogICAgICAgIDxwYXRoIGZpbGw9IiNDQ0MiIGQ9Ik0yMC4wNzEgNEg1LjkzQTEuOTMgMS45MyAwIDAgMCA0IDUuOTI5VjIwLjA3QTEuOTMgMS45MyAwIDAgMCA1LjkyOSAyMkgyMC4wN0ExLjkzIDEuOTMgMCAwIDAgMjIgMjAuMDcxVjUuOTNBMS45MyAxLjkzIDAgMCAwIDIwLjA3MSA0em0tLjI0IDE2LjA3MUg2LjE3YS4yNDIuMjQyIDAgMCAxLS4yNDEtLjI0VjYuMTdjMC0uMTMzLjEwOC0uMjQxLjI0LS4yNDFIMTkuODNjLjEzMyAwIC4yNDEuMTA4LjI0MS4yNFYxOS44M2EuMjQyLjI0MiAwIDAgMS0uMjQuMjQxeiIvPgogICAgICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgeD0iMSIgeT0iMSIgc3Ryb2tlPSIjRkY1QzI4IiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIHJ4PSIyIi8+CiAgICA8L2c+Cjwvc3ZnPgo=');
  }

  .form-item {
    margin-block-end: spacing(2);
    position: relative;
  }

  .togglePasswordVisibilityContainer {
    position: absolute;
    top: 1rem;
    right: 1.5rem;
    cursor: pointer;
    user-select: none;
    width: 2.4rem;
    height: 2.4rem;
    object-fit: contain;
    padding-inline-start: 0.5rem;

    :global([dir='rtl']) & {
      right: unset;
      left: 1.5rem;
    }
  }

  .input:focus + .togglePasswordVisibilityContainer {
    fill: $black;
  }
</style>

{#if type === 'checkbox'}
  <div class="form-item">
    <input class="input" type="checkbox" {id} {name} {required} bind:checked />
    <label class="checkbox-label" for={id}>
      <slot />
    </label>
  </div>
{:else}
  <div class="input-container">
    <input
      {pattern}
      {title}
      class="input {togglePasswordVisibility ? 'toggle-password' : ''}"
      class:error={hasErrors}
      {type}
      {id}
      {name}
      {placeholder}
      {required}
      {value}
      {readonly}
      {minlength}
      {maxlength}
      on:keyup={onKeyup}
      data-testid={testid}
    />
    {#if togglePasswordVisibility}
      <div
        class="{hasErrors ? 'error ' : ''}togglePasswordVisibilityContainer"
        on:click={tooglePasswordVisibility}
      >
        {#if passwordToggle}
          <Icon iconName="eye" iconType="regular" />
        {:else}
          <Icon iconName="eye-slash" iconType="regular" />
        {/if}
      </div>
    {/if}

    {#if errorMessages && errorMessages.length}
      <div class="error-message">
        {#each errorMessages as errorMessage}{@html errorMessage}{/each}
      </div>
    {/if}
  </div>
{/if}
